<template lang="pug">
    .slider__item(:style="{ backgroundImage: 'url(' + image + ')' }")
        .md-tb
            .md-tb__cell
                .slider__content
                    .container
                        h2 
                            | {{ lenguage.part1 }}
                            br
                            | {{ lenguage.part2 }}
                        p
                            i {{ lenguage.part3 }}
</template>

<script>
export default {
    props: ["image", "lenguage"]
}
</script>

<style lang="scss" scoped>
p{
    text-align: center!important;
}
</style>




// WEBPACK FOOTER //
// src/components/atoms/PmHomeSlider.vue